import React from "react";
import { Col } from "antd";
import { AuthHeroIllustration } from "./AuthHeroIllustration";

export const AuthHeroPanel: React.FC = () => {
  return (
    <Col xs={0} lg={14} className="relative min-h-full p-0">
      <div className="relative h-full min-h-full">
        <AuthHeroIllustration />
      </div>
    </Col>
  );
};
